import map from 'lodash/map';
import {normalize} from 'normalizr';
import {getHeaders, getMPMEndpoint} from '../../../helpers/endpoint';
import {statisticListSchema} from '../../../schemas/statistic';
import {receiveEntities} from '../../entities';

export const REQUEST_STATS_MPM_USERS = 'REQUEST_STATS_MPM_USERS';
export const SUCCESS_FETCH_STATS_MPM_USERS = 'SUCCESS_FETCH_STATS_MPM_USERS';
export const FAIL_FETCH_STATS_MPM_USERS = 'FAIL_FETCH_STATS_MPM_USERS';

export const fetchMPMUsersStatistics = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_STATS_MPM_USERS, payload, scope});
    fetch(getMPMEndpoint('fetchStatsMPMUsers', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_MPM_USERS});
        else dispatch(successFetchMPMUsersStatistics(data, payload, scope));
      })
      .catch((error, type = FAIL_FETCH_STATS_MPM_USERS) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchMPMUsersStatistics(data, payload, scope) {
  return dispatch => {
    let all = {};

    const mpmUsers = map(data.usersCreations, (stat, key) => {
      all = {
        ...all,
        mpgFr: (all && all.mpgFr ? all.mpgFr : 0) + stat.countries.FR.other,
        mpgEn: (all && all.mpgEn ? all.mpgEn : 0) + stat.countries.GB.other,
        mpgEs: (all && all.mpgEs ? all.mpgEs : 0) + stat.countries.ES.other,
        mpgOther:
          (all && all.mpgOther ? all.mpgOther : 0) + stat.countries.OTHER.other,
        mpmFr: (all && all.mpmFr ? all.mpmFr : 0) + stat.countries.FR.mpm,
        mpmEn: (all && all.mpmEn ? all.mpmEn : 0) + stat.countries.GB.mpm,
        mpmEs: (all && all.mpmEs ? all.mpmEs : 0) + stat.countries.ES.mpm,
        mpmOther:
          (all && all.mpmOther ? all.mpmOther : 0) + stat.countries.OTHER.mpm,
        all: all.mpmFr + all.mpmEn + all.mpmEs + all.mpmOther,
      };

      return {
        mpgFr: stat.countries.FR.other,
        mpgEn: stat.countries.GB.other,
        mpgEs: stat.countries.ES.other,
        mpgOther: stat.countries.OTHER.other,
        mpmFr: stat.countries.FR.mpm,
        mpmEn: stat.countries.GB.mpm,
        mpmEs: stat.countries.ES.mpm,
        mpmOther: stat.countries.OTHER.mpm,
        id: `mpmUsers-${key}`,
        date: key,
      };
    });

    const normalized = normalize(mpmUsers, statisticListSchema);

    dispatch(receiveEntities(normalized.entities));

    dispatch({
      type: SUCCESS_FETCH_STATS_MPM_USERS,
      receivedAt: Date.now(),
      ids: normalized.result,
      total: all,
      payload,
      scope,
    });
  };
}

export const REQUEST_MPM_USERS_BY_MATCHES =
  'REQUEST_FETCH_MPM_USERS_BY_MATCHES';
export const SUCCESS_MPM_USERS_BY_MATCHES =
  'SUCCESS_FETCH_MPM_USERS_BY_MATCHES';
export const FAIL_MPM_USERS_BY_MATCHES = 'FAIL_FETCH_MPM_USERS_BY_MATCHES';

export const getMPMUsersByMatches = (payload, onSuccess, onFail, onRequest) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_MPM_USERS_BY_MATCHES, payload});
    if (onRequest) onRequest(payload);

    fetch(getMPMEndpoint('fetchMPMUsersByMatches', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_MPM_USERS_BY_MATCHES});
        else
          dispatch({
            type: SUCCESS_MPM_USERS_BY_MATCHES,
            data: data,
          });

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_MPM_USERS_BY_MATCHES) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_MPM_USERS_CONNECTIONS = 'REQUEST_MPM_USERS_CONNECTIONS';
export const SUCCESS_MPM_USERS_CONNECTIONS = 'SUCCESS_MPM_USERS_CONNECTIONS';
export const FAIL_MPM_USERS_CONNECTIONS = 'FAIL_MPM_USERS_CONNECTIONS';

export const getMPMUsersConnections = (onSuccess, onFail, onRequest) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_MPM_USERS_CONNECTIONS});
    if (onRequest) onRequest();

    fetch(getMPMEndpoint('fetchMPMUsersConnections'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_MPM_USERS_CONNECTIONS});
        else dispatch({type: SUCCESS_MPM_USERS_CONNECTIONS, data});

        if (onSuccess) onSuccess(data);
      })
      .catch((error, type = FAIL_MPM_USERS_CONNECTIONS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_MPM_STATS_PLATFORMS = 'REQUEST_MPM_STATS_PLATFORMS';
export const SUCCESS_MPM_STATS_PLATFORMS = 'SUCCESS_MPM_STATS_PLATFORMS';
export const FAIL_MPM_STATS_PLATFORMS = 'FAIL_MPM_STATS_PLATFORMS';

export const getMPMStatsPlatforms = (payload, onSuccess, onFail, onRequest) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_MPM_STATS_PLATFORMS, payload});
    if (onRequest) onRequest(payload);

    fetch(getMPMEndpoint('fetchMPMStatsPlatforms', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_MPM_STATS_PLATFORMS});
        else {
          const users = data.usersConnections;
          const usersConnections = map({...users}, (stat, key) => {
            return {...stat, id: `usersConnections-${key}`, date: key};
          });
          dispatch({
            type: SUCCESS_MPM_STATS_PLATFORMS,
            data: {...data, usersConnections},
          });
        }

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_MPM_STATS_PLATFORMS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/mpmUsers.js